import { Inject, OnInit, PLATFORM_ID, OnDestroy } from '@angular/core';
import { Section, SectionControlSet } from '../template-generator/entity/section';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from '../generator-env-token';
import { SECTION_DATA } from './service/section-data';
import { isPlatformBrowser } from '@angular/common';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { TemplateService } from '../template-generator/service/template.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

/** 首頁區塊通用實作 */
export abstract class AbstractIndexSection<T> implements OnInit, OnDestroy {
  readonly apiHost = this.generatorEnv.apiHost;
  /** 到首頁的路徑 */
  toHomePath: string;
  /** 是瀏覽器端渲染 */
  isBrowser: boolean;
  /** 是否為 SSR 模式 */
  isSSRMode: boolean;
  /** 區塊目前為可編輯狀態(從載入器決定的值) */
  editable: boolean;
  /** 此section吃那些後台模組 */
  abstract belongSiteModules: Array<string>;
  /** 跟server要多少資料 */
  abstract limit: number;
  /** server資料位移量 */
  offset = 0;
  /** 模板區塊頁面呈現的自定義資料 */
  get data() { return this.section.data; }
  /** 模板區塊頁面呈現的自定義資料 */
  set data(d: SectionControlSet|any) { this.section.data = d; }
  /** 預設此模組資料 */
  abstract defaultData: any;
  /** 後端模組資料 */
  remoteData: T;
  /** 預設後端模組資料 */
  abstract remoteDefaultData: T;
  protected _loadRmtDataSubc: Subscription;

  constructor(
    @Inject(SECTION_DATA) protected section: Section,
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected serverConfigService: ServerConfigService,
    protected templateService: TemplateService,
    protected translate: TranslateService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.isSSRMode = this.serverConfigService.isSSRMode;
    this.toHomePath = `/${translate.currentLang}`;
  }

  ngOnInit() {
    // set data
    this.initData();
  }

  ngOnDestroy(): void {
    if (this._loadRmtDataSubc) { this._loadRmtDataSubc.unsubscribe(); }
  }

  /** 初始化區塊資料 */
  protected initData() {
    const defaultDataClone = JSON.parse(JSON.stringify(this.defaultData));
    if (this.section.data) {
      Object.assign(defaultDataClone, this.section.data);
      Object.assign(this.section.data, defaultDataClone);
    } else {
      this.section.data = defaultDataClone;
    }
    this.remoteData = this.remoteDefaultData;

    this.refreshRemoteData();
  }

  abstract refreshRemoteData(): void;

  /** 要求維持連線 */
  keepConnection() {
    this.templateService.keepConnection();
  }
}
